'use client'

import dynamic from 'next/dynamic'
import { useCallback, useState } from 'react'

// Split out of page.jsx so that page.jsx can stay a SERVER component and export `metadata`. The reference
// (Scalar) is large and renders in the browser only, so it loads lazily; until it has loaded, the
// server-rendered introduction (`children`) shows in its place.
const ApiReference = dynamic(() => import('./ApiReference'), { ssr: false })

export default function DocsViewer({ children }) {
  const [loaded, setLoaded] = useState(false)
  // Stable, so the reference's configuration (which carries it) never changes after the first render.
  const onLoaded = useCallback(() => setLoaded(true), [])
  return (
    <>
      {!loaded && children}
      <ApiReference onLoaded={onLoaded} />
    </>
  )
}
